export enum fundManagerFormFields {
  nameEn = 'nameEn',
  nameAr = 'nameAr',
  descriptionEn = 'descriptionEn',
  descriptionAr = 'descriptionAr',
  locationEn = 'locationEn',
  locationAr = 'locationAr',
  logoUrl = 'logoUrl',
}
